import { S } from "framer-motion/dist/types.d-DagZKalS";
import { Store } from "../../../entity/Store";
import { Method, ROUTES } from "../../configuration/Configuration";
import { fetchAPI } from "../../configuration/MainService";
import {
  mapToCreatedStore,
  mapToStore,
  mapToStores,
} from "../../mapper/StoreMapper";
import { NewStoreDto, StoreDto } from "../../dto/Store.Dto";

export class WSStore {
  private static instance: WSStore;

  private constructor() { }

  static getInstance(): WSStore {
    if (!this.instance) {
      this.instance = new WSStore();
    }
    return this.instance;
  }

  async getAllSTORE(): Promise<Store[]> {
    try {
      const url = `${ROUTES.STORE}${ROUTES.GET_ENABLED_STORES}`;

      const response = await fetchAPI<StoreDto[]>({
        url,
        method: Method.GET,
        params: {},
        isAuthenticated: true,
      });

      return mapToStores(response.data);
    } catch (error) {
      console.error("Get all operations failed:", error);
      throw error;
    }
  }

  async getAllEnaledSTORE(): Promise<Store[]> {
    try {
      const url = `${ROUTES.STORE}`;

      const response = await fetchAPI<StoreDto[]>({
        url,
        method: Method.GET,
        params: {},
        isAuthenticated: true,
      });

      return mapToStores(response.data);
    } catch (error) {
      console.error("Get all operations failed:", error);
      throw error;
    }
  }

  async getReleatedStoreByEmail(email: string): Promise<Store | null> {
    try {
      const url = `${ROUTES.STORE}${ROUTES.BY_EMAIL}${email}`;

      const response = await fetchAPI<StoreDto>({
        url,
        method: Method.GET,
        params: {},
        isAuthenticated: true,
      });

      return response.data ? mapToStore(response.data) : null;
    } catch (error) {
      console.error("Get all operations failed:", error);
      throw error;
    }
  }

  async getStoreBySubdomain(subdomain: string): Promise<Store | null> {
    try {
      const url = `${ROUTES.STORE}${ROUTES.BY_SUBDOMAIN}${subdomain}`;

      const response = await fetchAPI<StoreDto>({
        url,
        method: Method.GET,
        params: {},
        isAuthenticated: true,
      });

      return response.data ? mapToStore(response.data) : null;
    } catch (error) {
      console.error("Get all operations failed:", error);
      throw error;
    }
  }

  async getStoreById(storeId: string): Promise<Store | null> {
    try {
      const url = `${ROUTES.STORE}${ROUTES.STORE_BY_ID}${storeId}`;

      const response = await fetchAPI<StoreDto>({
        url,
        method: Method.GET,
        params: {},
        isAuthenticated: true,
      });

      return response.data ? mapToStore(response.data) : null;
    } catch (error) {
      console.error("Get all operations failed:", error);
      throw error;
    }
  }

  async createStore(store: Store): Promise<Store> {
    try {
      const url = `${ROUTES.STORE}${ROUTES.CREATE_STORES}`;

      const res = await fetchAPI<NewStoreDto>({
        url,
        method: Method.POST,
        params: store,
        isAuthenticated: true,
      });
      return mapToCreatedStore(store, res.data.id);
    } catch (error) {
      console.error("Failed to create store:", error);
      throw error;
    }
  }

  async deleteStore(id: string): Promise<void> {
    try {
      const url = `${ROUTES.STORE}${id}`;
      await fetchAPI({
        url,
        method: Method.DELETE,
        params: {},
        isAuthenticated: true,
      });
    } catch (error) {
      console.error("Failed to delete store:", error);
      throw error;
    }
  }

  async updateStore(store: Store): Promise<Store> {
    try {
      await fetchAPI({
        url: ROUTES.STORE,
        method: Method.PUT,
        params: store,
        isAuthenticated: true,
      });

      return store;
    } catch (error) {
      console.error("Failed to update store:", error);
      throw error;
    }
  }

  async checkSubdomainIfExist(subdomain: string): Promise<boolean> {
    try {
      const url = `${ROUTES.STORE}${ROUTES.CHECK_IF_SUBDOMAIN_EXISTS}${subdomain}`;
      const res = await fetchAPI<boolean>({
        url,
        method: Method.GET,
        params: {},
        isAuthenticated: true,
      });

      return res.data;
    } catch (error) {
      console.error("Failed to check subdomain:", error);
      throw error;
    }
  }

  async migrateData(data: string) { }

  async countStores(): Promise<number> {
    try {
      const url = `${ROUTES.STORE}${ROUTES.COUNT_STORES}`;
      const res = await fetchAPI<number>({
        url,
        method: Method.GET,
        params: {},
        isAuthenticated: true,
      });

      return res.data;
    } catch (error) {
      console.error("Failed to count stores:", error);
      throw error;
    }
  }

  async getLastStore(): Promise<Store> {
    try {
      const url = `${ROUTES.STORE}${ROUTES.LAST_STORE}`;
      const res = await fetchAPI<Store>({
        url,
        method: Method.GET,
        params: {},
        isAuthenticated: true,
      });

      return res.data;
    } catch (error) {
      console.error("Failed to get last store:", error);
      throw error;
    }
  }

  async deleteStorePermanently(id: string): Promise<void> {
    try {
      const url = `${ROUTES.STORE}${ROUTES.DELETE_PERMANENTLY}${id}`;
      await fetchAPI({
        url,
        method: Method.DELETE,
        params: {},
        isAuthenticated: true,
      });
    } catch (error) {
      console.error("Failed to delete store permanently:", error);
      throw error;
    }
  }
}
